var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUserFull = function SvgUserFull(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 18,
    fill: "none",
    viewBox: "0 0 16 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M7.875 11.25c1.652 0 2.11-.562 3.129-.562 2.601 0 4.746 2.144 4.746 4.746v.879c0 .949-.773 1.687-1.687 1.687H1.688C.738 18 0 17.262 0 16.313v-.88c0-2.601 2.11-4.745 4.71-4.745 1.02 0 1.478.562 3.165.562M12.938 5.063a5.064 5.064 0 0 1-5.063 5.062 5.04 5.04 0 0 1-5.062-5.062A5.064 5.064 0 0 1 7.875 0c2.777 0 5.063 2.285 5.063 5.063"
  })));
};
export default SvgUserFull;